<template>
  <div
    class="modal fade"
    id="locationDataTranslateModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>

          <h4 class="modal-title">
            <b>{{ lang.LTM000 }}</b>
          </h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="col-md-2 control-label"
              >{{ lang.LTM001 }} / {{ lang.LTM002 }}</label
            >
            <div class="col-md-4">
              <select2
                class="form-control"
                ref="selectLocalizedLocationDataCountryCode"
                v-model="selectedCountry"
                @change="selectedLanguage = ''"
                :placeholder="lang.LTM003"
                :allowClear="true"
                @open="currentTranslationDataDirty && showDirtyDataWarning()"
              >
                <option></option>
                <option
                  v-for="(country, ISOCode) in countryList"
                  :key="ISOCode"
                  :value="ISOCode"
                >
                  {{ country }}
                </option>
              </select2>
            </div>
            <div class="col-md-4">
              <select2
                class="form-control"
                ref="selectLocalizedLocationDataLanguageCode"
                v-model="selectedLanguage"
                :disabled="!selectedCountry"
                :placeholder="lang.LTM004"
                :allowClear="true"
                @open="currentTranslationDataDirty && showDirtyDataWarning()"
              >
                <option></option>
                <option
                  v-for="language in currentCountryLanguages"
                  :key="language.LanguageCode"
                  :value="language.LanguageCode"
                >
                  {{ language.LanguageName }}
                </option>
              </select2>
            </div>
            <div class="col-md-2">
              <button
                class="btn btn-default btn-fab"
                :disabled="
                  !selectedLanguage || !currentTranslationData.LocationGuid
                "
                @click="deleteTranslationData()"
              >
                <i class="material-icons md-36 text-red">clear</i>
              </button>
            </div>

            <template v-if="selectedLanguage">
              <div
                class="col-md-12 location-translation-form"
                v-if="!currentTranslationData.LocationGuid"
              >
                {{ lang.LTM005 }}
                <br />
                <br />
                <button
                  class="btn btn-default btn-fab"
                  @click="addNewTranslationData()"
                >
                  <i class="material-icons md-36 text-green">add</i>
                </button>
              </div>
              <div
                class="col-md-12 location-translation-form"
                v-else
                @input="currentTranslationDataDirty = true"
              >
                <div class="form-group">
                  <label
                    for="inputLocationTranslationLocationName"
                    class="col-md-2 control-label"
                    >{{ lang.LTM006 }}</label
                  >
                  <label class="col-md-5 base-data-label">{{
                    baseLocationData.LocationName
                  }}</label>
                  <div class="col-md-5">
                    <input
                      type="text"
                      class="form-control"
                      id="inputLocationTranslationLocationName"
                      v-model="currentTranslationData.LocationName"
                      maxlength="50"
                    />
                  </div>
                </div>

                <div class="form-group">
                  <label
                    for="inputLocationTranslationAddress"
                    class="col-md-2 control-label"
                    >{{ lang.LTM007 }}</label
                  >
                  <label class="col-md-5 base-data-label">{{
                    baseLocationData.LocationAddress
                  }}</label>
                  <div class="col-md-5">
                    <input
                      type="text"
                      class="form-control"
                      id="inputLocationTranslationAddress"
                      v-model="currentTranslationData.LocationAddress"
                      maxlength="150"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label
                    for="inputLocationTranslationAddress2"
                    class="col-md-2 control-label"
                    >{{ lang.LTM008 }}</label
                  >
                  <label class="col-md-5 base-data-label">{{
                    baseLocationData.LocationAddress2
                  }}</label>
                  <div class="col-md-5">
                    <input
                      type="text"
                      class="form-control"
                      id="inputLocationTranslationAddress2"
                      v-model="currentTranslationData.LocationAddress2"
                      maxlength="150"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label
                    for="inputLocationTranslationLocationCounty"
                    class="col-md-2 control-label"
                    >{{ lang.LTM009 }}</label
                  >
                  <label class="col-md-5 base-data-label">{{
                    baseLocationData.LocationCounty
                  }}</label>
                  <div class="col-md-5">
                    <input
                      type="text"
                      class="form-control"
                      id="inputLocationTranslationLocationCounty"
                      v-model="currentTranslationData.LocationCounty"
                      maxlength="250"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label
                    for="inputLocationTranslationLocationCity"
                    class="col-md-2 control-label"
                    >{{ lang.LTM010 }}</label
                  >
                  <label class="col-md-5 base-data-label">{{
                    baseLocationData.LocationCity
                  }}</label>
                  <div class="col-md-5">
                    <input
                      type="text"
                      class="form-control"
                      id="inputLocationTranslationLocationCity"
                      v-model="currentTranslationData.LocationCity"
                      maxlength="50"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label
                    for="inputLocationTranslationLocationPostalCode"
                    class="col-md-2 control-label"
                    >{{ lang.LTM011 }}</label
                  >
                  <label class="col-md-5 base-data-label">{{
                    baseLocationData.LocationPostalCode
                  }}</label>
                  <div class="col-md-5">
                    <input
                      type="text"
                      class="form-control"
                      id="inputLocationTranslationLocationPostalCode"
                      v-model="currentTranslationData.LocationPostalCode"
                      maxlength="12"
                    />
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-raised btn-default"
            data-dismiss="modal"
          >
            {{ lang.LTM012 }}
          </button>
          <button
            type="button"
            class="btn btn-raised btn-success"
            :class="{ 'btn-warning': currentTranslationDataDirty }"
            @click="saveLocalizedLocationData()"
          >
            {{ lang.LTM013 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "../Tools/Select2";

export default {
  name: "LocationDataTranslateModal",
  components: {
    Select2,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    selectedLocation: {
      type: String,
      default: "",
    },
    selectedLocationId: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      selectedCountry: "",
      selectedLanguage: "",
      countryList: [],
      countryLanguages: [],
      translationDataList: [],
      baseLocationData: {},
      currentTranslationDataDirty: false,
      lang: {
        LTM000: "Translate location data",
        LTM001: "Country",
        LTM002: "Language",
        LTM003: "Please select a country...",
        LTM004: "Please select a language...",
        LTM005: "No translation data for this language stored yet.",
        LTM006: "Name of the location",
        LTM007: "Street",
        LTM008: "Addition to address",
        LTM009: "Region",
        LTM010: "City",
        LTM011: "Postal code",
        LTM012: "Close",
        LTM013: "Save",
        LTM014: "Unsaved Changes",
        LTM015: "Save",
        LTM016: "Discard changes",
        LTM017:
          "There are unsaved changes for the current translation entry. Do you want to save them?",
        LTM018: "Location data access failed",
        LTM019: "Localized location data access failed",
        LTM020: "Translation data update successful",
        LTM021: "Translation data update failed",
      },
    };
  },
  computed: {
    currentCountryLanguages() {
      if (!this.selectedCountry) return [];
      let countryObj = _.find(
        this.countryLanguages,
        (country) => country.CountryCode === this.selectedCountry
      );
      if (countryObj) return countryObj.Languages || [];
      return [];
    },
    currentTranslationData() {
      if (!this.selectedLanguage) return {};
      let data = _.find(
        this.translationDataList,
        (trData) =>
          trData.CountryCode === this.selectedCountry &&
          trData.LanguageCode === this.selectedLanguage
      );
      return data || {};
    },
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
      this.globals.getCountryList((data) => (this.countryList = data));
    },
    showModal(newVal) {
      if (newVal) this.openModal();
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    this.getSelectData();

    $("#locationDataTranslateModal").on("hidden.bs.modal", (e) =>
      this.$emit("modalClosed")
    );

    this.globals.$off("IgnoreUnsavedLocationTranslationYesConfirmation");
    this.globals.$on(
      "IgnoreUnsavedLocationTranslationYesConfirmation",
      this.saveLocalizedLocationData
    );
    this.globals.$off("IgnoreUnsavedLocationTranslationNoConfirmation");
    this.globals.$on(
      "IgnoreUnsavedLocationTranslationNoConfirmation",
      this.getLocalizedLocationData
    );
  },
  methods: {
    openModal() {
      this.getLocalizedLocationData();
      this.getBaseLocationData();
    },
    closeModal() {
      $("#locationDataTranslateModal").modal("hide");
    },
    showDirtyDataWarning() {
      this.$refs.selectLocalizedLocationDataCountryCode.close();
      this.$refs.selectLocalizedLocationDataLanguageCode.close();

      this.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "IgnoreUnsavedLocationTranslation",
        confirmationTitle: this.lang.LTM014,
        colorRed: true,
        yesButtonText: this.lang.LTM015,
        noButtonText: this.lang.LTM016,
        htmlText: `<p>${this.lang.LTM017}</p>`,
      });
    },
    addNewTranslationData() {
      this.translationDataList.push({
        LocationGuid: this.selectedLocation,
        CountryCode: this.selectedCountry,
        LanguageCode: this.selectedLanguage,
      });
    },
    getBaseLocationData() {
      if (this.selectedLocationId < 0) return;

      $.ajax({
        method: "GET",
        url: `api/Locations/${this.selectedLocationId}`,
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.baseLocationData = data;
        },
        error: () => {
          console.error("Error on GET in getBaseLocationData()");
          this.globals.showErrorSnackbar(this.lang.LTM018);
        },
      });
    },
    getLocalizedLocationData() {
      if (!this.selectedLocation) return;

      $.ajax({
        method: "GET",
        url: `api/Locations/${this.selectedLocation}/Translations`,
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.translationDataList = data;
          this.currentTranslationDataDirty = false;
          if (!$("#locationDataTranslateModal").hasClass("in"))
            $("#locationDataTranslateModal").modal("show");
        },
        error: () => {
          console.error("Error on GET in getLocalizedLocationData()");
          this.globals.showErrorSnackbar(this.lang.LTM019);
          this.$emit("modalClosed");
        },
      });
    },
    saveLocalizedLocationData() {
      let queryString = `api/Locations/${this.selectedLocation}/Translations`;
      let reqMethod = "POST";
      if (this.currentTranslationData.LocationTranslationGuid) {
        queryString = `api/Locations/Translations/${this.currentTranslationData.LocationTranslationGuid}`;
        reqMethod = "PUT";
      }

      $.ajax({
        method: reqMethod,
        url: queryString,
        data: JSON.stringify(this.currentTranslationData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          if (data && data[0]) this.translationDataList = data;
          this.currentTranslationDataDirty = false;
          this.globals.showSuccessSnackbar(this.lang.LTM020);
        },
        error: () => {
          console.error("Error on POST in saveLocalizedLocationData()");
          this.globals.showErrorSnackbar(this.lang.LTM021);
        },
      });
    },
    deleteTranslationData() {
      if (!this.currentTranslationData.LocationTranslationGuid) {
        this.removeCurrentTranslationFromList();
        return;
      }
      let queryString = `api/Locations/Translations/${this.currentTranslationData.LocationTranslationGuid}`;

      $.ajax({
        method: "DELETE",
        url: queryString,
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.removeCurrentTranslationFromList();
          this.globals.showSuccessSnackbar(this.lang.LTM020);
        },
        error: () => {
          console.error("Error on DELETE in deleteTranslationData()");
          this.globals.showErrorSnackbar(this.lang.LTM021);
        },
      });
    },
    removeCurrentTranslationFromList() {
      _.remove(
        this.translationDataList,
        (td) =>
          td.CountryCode === this.selectedCountry &&
          td.LanguageCode === this.selectedLanguage
      );
      let tmpLang = this.selectedLanguage;
      this.selectedLanguage = "";
      this.currentTranslationDataDirty = false;
      this.$nextTick(() => {
        this.selectedLanguage = tmpLang;
      });
    },
    getSelectData() {
      if (this.globals.selectedLanguage) {
        this.globals.getCountryList((data) => (this.countryList = data));
      }
      this.globals.getCountryLanguageList((callbackData) => {
        this.countryLanguages = callbackData;
      });
    },
  },
};
</script>

<style scoped>
.location-translation-form {
  border: 2px solid lightgray;
  border-radius: 10px;
  margin-top: 30px;
  padding: 10px;
}

.btn-fab {
  width: 40px !important;
  height: 40px !important;
  min-width: 40px !important;
  border: 2px solid #ddd;
  background: white !important;
  font-size: 36px;
}
.btn-fab:disabled > .text-red {
  color: rgba(255, 0, 0, 0.5) !important;
}
.btn-fab .material-icons {
  position: absolute !important;
  left: 12px !important;
  top: 18px !important;
}

.base-data-label {
  min-height: 45px;
  margin: 0;
  text-align: left;
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// LocationDataTranslateModal.vue?931f36a4